const CardComponent = ({ col, children }: { col: number, children: JSX.Element }) => {

    return (
        <div className={`col-md-${col}`}>
            <div className="card card-raised mb-5">
                <div className="card-body p-5">
                    {children}
                </div>
            </div>
        </div>
    )

}

export default CardComponent;